import React, { useState } from 'react';
import LayoutV2 from '../../../components/layout-v2';
import UButton from 'ubs-framework/v2/UButton';
import UProgressBar from '../../../common/component/UStaticprogressbar';
import { createCookie, getCookie } from 'ubs-framework/v2/common/function';
import { constant } from '../../../common/constant';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { sendData } from '../../../store/actions';

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const BuildingAccount = () => {
  const dispatch = useDispatch()
  const [isBuilding, setIsBuilding] = useState(true);
  const {orgId} = useParams();
  const history = useHistory();

  const setUpDone = () => {
    localStorage.removeItem('slugType')
    localStorage.removeItem('signUpStep')
    localStorage.removeItem('signUpOrgId')
    sendData(dispatch, 'authenticate', {token: getCookie("signup_token")})
    createCookie('ubs_token', getCookie("signup_token"), constant.COOKIE_DAYS)
    window.location.href = `${process.env.REACT_APP_TRACK_MODULE_URL}/${orgId}/dashboard`
  }

  return (
    <LayoutV2 module="" className="u_collect-details">
      <div className="u_p-24">
        {isBuilding ? (
          <>
            <div className="u_flex u_content-center">
              <img src="/images/building.png" alt="building" />
            </div>
            <h4 className="u_title u_text-center u_text-bold u_mt-16 u_mb-16">
              Amazing! We’re building your account.
            </h4>
            <p className="u_small-font u_mb-16 u_text-center">
              This won't take long—just a minute or two.
            </p>

            <UProgressBar
              color="blue"
              duration={7000}
              style={{ width: '250px', minWidth: '100px' }}
              onComplete={() => setIsBuilding(false)}
            />
          </>
        ) : (
          <>
            <div className="u_flex u_content-center">
              <img src="/images/setup-success.png" alt="setup-success" />
            </div>
            <h4 className="u_title u_text-center u_text-bold u_mt-24 u_mb-12">
              Your organization setup successfully
            </h4>
            <p className="u_small-font u_mb-24 u_text-center">
              Let's explore all the features to help your business or company grow.
            </p>
            <div className="u_flex u_content-center">
              <UButton
                style={{ width: 'auto', borderRadius: '6px' }}
                variant="blue"
                type="Go to Dashboard"
                onClick={() => setUpDone()}
                testId={TEST_ID.BUILDING_ACCOUNT.BUTTON} />
            </div>
            {/* <div className="u_block u_relative">
              <button type="button" onClick={setUpDone} data-testid={TEST_ID.BUILDING_ACCOUNT.SETUP_DONE_BUTTON}  className={`u_account-btn u_w-full u_cp`}>Go to Dashboard</button>
            </div> */}
          </>
        )}
      </div>
    </LayoutV2>
  );
};

export default BuildingAccount;